import React from 'react';
import { CASE_ITEM_FIELDS } from './PdfCasesSummaryItens';
import { useTranslation } from 'react-i18next';

const PdfCasesSummaryHeader: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="pdf-cases-summary-line pdf-cases-summary-header">
      {CASE_ITEM_FIELDS.map((field) => (
        <span className="pdf-cases-summary-cell" style={{ gridArea: field }}>
          {t(`pdf:${field}.title`, { defaultValue: field })}
        </span>
      ))}
    </div>
  );
};

export default PdfCasesSummaryHeader;
